const pass = (rule, value, callback) => {
  if (value) {
    callback();
  } else {
    callback();
  }
};
export const warehouseGoodsDetailOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  // columnBtn: false,
  addTitle: "新增入库",
  menuWidth: "300",
  labelWidth: "150",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "产品类型",
      prop: "goodsType",
      type: "select",
      addVisdiplay: false,
      editVisdiplay: false,
      dicData: [
        {
          label: "防水",
          value: "WATERPROOF",
        },
        {
          label: "净水",
          value: "PURE_WATER",
        },
        {
          label: "吊顶",
          value: "HANG_CEILING",
        }
      ],
    },
    {
      label: "产品",
      prop: "goodsName",
      search: false,
      formsolt: true,
      addVisdiplay: false,
      editVisdiplay: false,
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    {
      label: "产品数量",
      prop: "num",
      type: "input",
      addVisdiplay: false,
      editVisdiplay: false,
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    {
      label: "操作类型",
      prop: "type",
      type: "select",
      search: true,
      addVisdiplay: false,
      editVisdiplay: false,
      dicData: [
        {
          label: "入库",
          value: "INCREASE",
        },
        {
          label: "出库",
          value: "REDUCE",
        },
      ],
      formatter: (row) => {
        if (row.businessType === 1) {
          return row.type === "INCREASE" ? "退货入库" : "出库";
        }
        return row.type === "INCREASE" ? "入库" : "出库";
      }
    },
    {
      label: "操作人姓名",
      prop: "consigneeName",
      search: true,
      addVisdiplay: false,
      editVisdiplay: false,
      formatter: (row) => {
        if (row.businessType === 1) {
          return row.createBy;
        }
        return row.consigneeName;
      }
    },
    {
      label: "操作人电话",
      prop: "consigneeMobile",
      search: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },

    {
      label: "凭证",
      prop: "picUrl",
      span: 24,
      solt: true,
      formsolt: true,
    },
    {
      label: "状态",
      prop: "status",
      type: "select",
      search: true,
      addVisdiplay: false,
      editVisdiplay: false,
      dicData: [
        {
          label: "待入库",
          value: "PENDING_STORAGE",
        },
        {
          label: "已入库",
          value: "ALREADY_IN_STOCK",
        }
      ],
    },
    {
      label: "操作时间",
      prop: "createTime",
      type: "datetime",
      sortable: true,
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
  ],
};
